import { HistoryEvent } from '@api/types';
import { isUninstallEvent } from '@react/constants/historyEvent/utils';

class UninstallPrepareActionParser {
  check = isUninstallEvent;

  getAction(event: HistoryEvent): string {
    const { action } = event.attributes;
    const { store } = event.attributes.parameters;

    const overrides = {
      'created@itunes': 'uploaded',
      'created@google': 'added',
      'updated@itunes': 'changed',
      'updated@google': 'changed',
    };

    return overrides[`${action}@${store}`] || action;
  }
}

export const uninstallPrepareActionParser = new UninstallPrepareActionParser();
